import { instance } from '@/services/avik-api-gateway'
import { PenaltyAssessment } from '@/types/penalty-assessment'
import { AxiosResponse } from 'axios'

export function createEventPenaltyAssessment(
  body: Partial<PenaltyAssessment>
): Promise<AxiosResponse<PenaltyAssessment>> {
  return instance.post(`/event-penalty-assessment`, body)
}
